// 友情链接
export const homeFriendlinks = [{
  url: 'http://learning.sohu.com',
  title: '搜狐教育'
},
{
  url: 'http://edu.people.com.cn',
  title: '人民教育网'
},
{
  url: 'http://edu.sina.com.cn',
  title: '新浪教育'
},
{
  url: 'http://www.exam8.com',
  title: '考试吧'
},
{
  url: 'http://www.docin.com',
  title: '豆丁网'
},
{
  url: 'http://www.chinakaoyan.com',
  title: '考研网'
},
{
  url: 'http://www.kekenet.com',
  title: '可可英语'
},
{
  url: 'http://www.51test.net',
  title: '无忧考'
},
{
  url: 'http://www.jobui.com',
  title: '网职友集'
},
{
  url: 'https://www.uhouzz.com',
  title: '异乡好居'
},
{
  url: 'http://www.dongao.com',
  title: '东奥会计在线'
},
{
  url: 'http://www.huatu.com',
  title: '华图教育'
},
{
  url: 'http://www.233.com',
  title: '233网教育'
}]



// WEBPACK FOOTER //
// ./src/api/js/home/friendlinks.js